module.exports = __webpack_public_path__ + "img/product_98.66bd63d.webp";